import { use } from 'react'
import { ScrollContext } from './ScrollContext'

export function useScrollContext() {
  const context = use(ScrollContext)

  if (!context) {
    throw new Error('useScrollContext must be used within a ScrollProvider')
  }

  return context
}
